import { OnInit, OnDestroy, Component, ChangeDetectionStrategy, ChangeDetectorRef, Output, EventEmitter, Input, ViewEncapsulation, ViewChild } from "@angular/core";
import { ICoveredCallTradeTypes, IUIDropDown, ICoveredCall } from "@irb/irb-editors/rebalance/irb-rebalance.model";
import { RebalanceService } from "@irb/irb-editors/rebalance/rebalance.service";
import { UtilityService } from "@irb/irb-common/services/utility.service";
import { AppService } from "@irb/app.service";
import { IAlertDialogData } from '@irb/app.model';
import { IrbAppEvents } from '@irb/app.events';
import { DropdownFilterComponent } from "@irb/irb-common/components/dropdown-filter/dropdown-filter.component";
import { IDropdownItem } from "@irb/irb-common/models/dropdown.model";

@Component({ standalone: false,
    selector: "coveredcall-rebal-settings",
    templateUrl: "./coveredcall-rebal-settings.component.html",
    styleUrls: [ 
        "./coveredcall-rebal-settings.component.scss"
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default
})
export class CoveredcallRebalSettingsComponent implements OnInit, OnDestroy {
    @ViewChild('IrbDropdownFilterOff') selectReference: DropdownFilterComponent;

    @Output() change = new EventEmitter<any>();
    
    _data: ICoveredCall;
    _isReadOnly: boolean;

    _coveredCallTradeTypes: ICoveredCallTradeTypes;
    _coveredCallTradeTypeList: Array<IDropdownItem>;
    _defaultCoveredCallTradeType: IDropdownItem;
    previousCoveredCallTradeType: IDropdownItem;

    viewMode = 'SELL_COVER_CALL';
    isUiTest = false;

    constructor(private cdr: ChangeDetectorRef, 
        private util: UtilityService, 
        private readonly rebalanceService: RebalanceService,
        private as: AppService) {
    }

    ngOnInit(): void {
        this.load();
    }

    ngOnDestroy(): void {
    }

    setChainTypeOptions(searchStr: any) {
        this.selectReference.set(DropdownFilterComponent.getFilteredList(searchStr,this.coveredCallTradeTypeList));
    }
    
    selectOption(event: IDropdownItem) {
        this.defaultCoveredCallTradeType = event;
        this.onTradeTypeModified();
    }

    load() {
        if (this.isReadOnly && this.data && this.data.action) {
            this.viewMode = this.data.action;
            this.populateCCTradeType(this.data.action);
            let defaultType:any = {name: this.defaultCoveredCallTradeType.name, id: this.defaultCoveredCallTradeType.value, versionId: null}
            this.coveredCallTradeTypes = {label: 'name', identifier: 'name', items: [defaultType]};
            this.coveredCallTradeTypeList = [this.defaultCoveredCallTradeType];

        } else {
            if (this.data.action === null || this.data.action === undefined) {
                this.data.action = 'SELL_COVER_CALL';
            }
            this.viewMode = this.data.action;
            this.populateCCTradeType(this.data.action);
            this.previousCoveredCallTradeType = this.util.clone(this.defaultCoveredCallTradeType);
            this.rebalanceService.getCoveredCallTradeTypes().subscribe((data: any) => {
                this.coveredCallTradeTypes = data.responseData;
                this.coveredCallTradeTypeList = [];
                if(data && data?.responseData && data?.responseData?.items && data?.responseData?.items?.length > 0) {
                    data?.responseData?.items?.forEach((cctype:IUIDropDown)=>{
                        let ccTypeItem: IDropdownItem = {
                            name: cctype.name,
                            value: cctype.id
                        };
                        this.coveredCallTradeTypeList.push(ccTypeItem);
                    });
                } else {
                    this.coveredCallTradeTypeList = [];
                }
            });
        }
    }

    onAllowInModified() {
        this.change.emit(true);
    }

    onOptionSettingsModified() {
        this.change.emit(true);
    }

    private populateCCTradeType(action: string) {
        switch(action) {
            case 'SELL_COVER_CALL':
                this.defaultCoveredCallTradeType = {name: "Sell covered call", value: "SELL_COVER_CALL"} as IDropdownItem;
                break;
            case 'BUY_TO_COVER':
                this.defaultCoveredCallTradeType = {name: "Buy to cover", value: "BUY_TO_COVER"} as IDropdownItem;
                break;
            case 'PURCHASE_UNDERLYING_SELL_COVER_CALL':
                this.defaultCoveredCallTradeType = {name: "Purchase underlying sell covered call", value: "PURCHASE_UNDERLYING_SELL_COVER_CALL"} as IDropdownItem;
                break;
            case 'ROLL_COVER_CALL':
                this.defaultCoveredCallTradeType = {name: "Roll covered call", value: "ROLL_COVER_CALL"} as IDropdownItem;
                break;
        }
    }

    private modifyCoveredCallOptions() {
        this.previousCoveredCallTradeType = this.util.clone(this.defaultCoveredCallTradeType);
        this.data.action = this.defaultCoveredCallTradeType.value;
        this.data.allocations = [];
        this.onOptionSettingsModified();
        this.viewMode = this.defaultCoveredCallTradeType.value;
        // switch(this.defaultCoveredCallTradeType.value) {
        //     case 'SELL_COVER_CALL':
        //         console.log(this.defaultCoveredCallTradeType);
        //         //TODO: implementation required
        //         break;
        //     case 'BUY_TO_COVER':
        //         console.log(this.defaultCoveredCallTradeType);
        //         //TODO: implementation required
        //         break;
        //     case 'PURCHASE_UNDERLYING_SELL_COVER_CALL':
        //         console.log(this.defaultCoveredCallTradeType);
        //         //TODO: implementation required
        //         break;
        //     case 'ROLL_COVER_CALL':
        //         console.log(this.defaultCoveredCallTradeType);
        //         //TODO: implementation required
        //         break;
        // }
    }

    onTradeTypeModified() {
        if (this.data.allocations && this.data.allocations.length) {
            this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                msg: "Changing the Trade Type will remove your selected options. Do you want to continue?",
                dCancelBtnLabel: "Cancel",
                onCancel: (() => {
                    this.defaultCoveredCallTradeType = this.util.clone(this.previousCoveredCallTradeType);
                }).bind(this),
                onProceed: (() => {
                    this.modifyCoveredCallOptions();
                }).bind(this)
              } as IAlertDialogData);
        } else {
            this.modifyCoveredCallOptions();
        }
    }

    @Input()
    get data() {
        return this._data;
    }

    set data(data: ICoveredCall) {
        this._data = data;
    }

    @Input()
    get isReadOnly() {
        return this._isReadOnly;
    }

    set isReadOnly(isReadOnly: boolean) {
        this._isReadOnly = isReadOnly;
    }

    get coveredCallTradeTypes() {
        return this._coveredCallTradeTypes;
    }

    set coveredCallTradeTypes(coveredCallTradeTypes: ICoveredCallTradeTypes) {
        this._coveredCallTradeTypes = coveredCallTradeTypes;
    }

    get defaultCoveredCallTradeType() {
        return this._defaultCoveredCallTradeType;
    }

    set defaultCoveredCallTradeType(defaultCoveredCallTradeType: IDropdownItem) {
        this._defaultCoveredCallTradeType = defaultCoveredCallTradeType;
    }
    get coveredCallTradeTypeList() {
        return this._coveredCallTradeTypeList;
    }

    set coveredCallTradeTypeList(coveredCallTradeTypeList: Array<IDropdownItem>) {
        this._coveredCallTradeTypeList = coveredCallTradeTypeList;
    }
}
